import React, { useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { accountType, accountUsage } from "./../../../utils/data/account_type";
import {
  createChartAccount,
  getGlGroups,
  resetChartOfAccountStatus,
} from "../../../redux/slice/accounting/accountingSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Select from "../../form/select/Select";
const AddAccount = ({ modal_id }) => {
  const { gl_groups, isUpdated } = useSelector((state) => state?.accounting);
  const [glgroup, setGlgroup] = useState({ error: "", account_type: "" });

  // const [selected, setSelectValue] = useState(null);

  const close = useRef();
  const selectRef = useRef();
  const accountUsageSelectRef = useRef();
  const GLSelectRef = useRef();
  const form = useRef();
  const dispatch = useDispatch();

  const onSubmit = (values) => {
    let payload = { ...values };
    if (values?.account_usage === 1) {
      setGlgroup({ ...glgroup, error: "" });
    }

    // if (!values?.gl_group && values?.account_usage === 2) {
    //   setGlgroup({ ...glgroup, error: "GL group cannot be blank" });
    //   return;
    // }

    if (values?.account_usage == "1") {
      const { gl_group, ...remaining } = payload;
      if (!values?.external_id) {
        const { external_id, ...rest } = remaining;
        dispatch(createChartAccount(rest));
        return;
      }
      dispatch(createChartAccount(remaining));
    } else {
      if (!values?.external_id) {
        const { external_id, ...rest } = payload;
        dispatch(createChartAccount(rest));
        return;
      }
      dispatch(createChartAccount(payload));
    }
  };

  const validationScehma = Yup.object().shape({
    account_name: Yup.string("Account Name must be a string").required(
      "Account Name cannot be blank"
    ),
    gl_code: Yup.string("GL code must be a string").required(
      "GL Code cannot be blank"
    ),
    account_usage: Yup.string("Account Usage must be a string").required(
      "Account Usage cannot be blank"
    ),
    account_type: Yup.string("Account type must be a string").required(
      "Account type cannot be blank"
    ),
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues: {
      account_name: "",
      account_type: "",
      gl_code: "",
      external_id: "",
      account_usage: "",
      manual_entries: "",
      gl_group: "",
      description: "",
    },
    validationSchema: validationScehma,
    onSubmit,
    onReset: () => {
      selectRef?.current?.clearValue();
      accountUsageSelectRef?.current?.clearValue();
      GLSelectRef?.current?.clearValue();
    },
  });

  useEffect(() => {
    if (isUpdated) {
      close.current?.click();
      dispatch(resetChartOfAccountStatus());
      resetForm();
    }
  }, [isUpdated]);

  useEffect(() => {
    if (values?.account_type) {
      dispatch(getGlGroups(values?.account_type));
    }
  }, [values?.account_type]);

  return (
    <>
      <div
        className='modal fade'
        id={modal_id}
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabIndex='-1'
        aria-labelledby='staticBackdropLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-scrollable' role='document'>
          <form
            className='modal-content rounded-4'
            ref={form}
            onSubmit={handleSubmit}
          >
            <div className='modal-header'>
              <h4 className='modal-title text-primary-1' id='myLargeModalLabel'>
                Create a General Ledger Account
              </h4>
              <span
                type='button'
                className=' bg-gray hover rounded-circle border-none'
                data-bs-dismiss='modal'
                aria-hidden='true'
                ref={close}
                onClick={() => {
                  resetForm();
                  form.current.reset();
                }}
                style={{ padding: "0px 3px" }}
              >
                <i
                  className='mdi mdi-close text-white'
                  style={{ fontSize: "16px" }}
                ></i>
              </span>
            </div>

            <div className='modal-body'>
              <div className='px-3'>
                <div className='row mb-3'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label
                      htmlFor='username'
                      className={`form-label mt-1  ${
                        errors?.account_name &&
                        touched?.account_name &&
                        "text-danger"
                      }`}
                    >
                      Account Name <span className='text-danger'>*</span>
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <input
                      type='text'
                      id='account_name'
                      name='account_name'
                      className={`form-control form-control-sm ${
                        errors?.account_name &&
                        touched?.account_name &&
                        "is-invalid"
                      }`}
                      value={values?.account_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors?.account_name && touched?.account_name && (
                      <p className='text-danger  mb-0'>
                        {errors?.account_name}
                      </p>
                    )}
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label
                      htmlFor='gl_code'
                      className={`form-label mt-1 ${
                        errors?.gl_code && touched?.gl_code && "text-danger"
                      }`}
                    >
                      GL Code <span className='text-danger'>*</span>
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <input
                      className={`form-control form-control-sm ${
                        errors?.gl_code && touched?.gl_code && "is-invalid"
                      }`}
                      name='gl_code'
                      value={values?.gl_code}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      type='text'
                      id='gl_code'
                    />
                    {errors?.gl_code && touched?.gl_code && (
                      <p className='text-danger  mb-0'>{errors?.gl_code}</p>
                    )}
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label
                      htmlFor='account_type'
                      className={`form-label mt-1 ${
                        errors?.account_type && touched?.account_type
                          ? "text-danger"
                          : ""
                      }`}
                    >
                      Account Type <span className='text-danger'>*</span>
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <Select
                      ref={selectRef}
                      isError={errors?.account_type && touched?.account_type}
                      name='account_type'
                      data={accountType.map((item, i) => ({
                        label: item,
                        value: i + 1,
                      }))}
                      value={values.account_type}
                      onChange={(selectedOption) =>
                        setFieldValue("account_type", selectedOption?.value)
                      }
                      onBlur={() => {
                        handleBlur({ target: { name: "account_type" } });
                      }}
                    />
                    {errors?.account_type && touched?.account_type && (
                      <p className='text-danger mb-0'>{errors?.account_type}</p>
                    )}
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label
                      htmlFor='external_id'
                      className='form-label'
                      style={{ textAlign: "right" }}
                    >
                      External ID
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <input
                      className='form-control form-control-sm'
                      type='text'
                      id='external_id'
                      value={values?.external_id}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                </div>

                <div className='row mb-3'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label
                      htmlFor='account_usage'
                      className={`form-label mt-1 ${
                        errors?.account_usage &&
                        touched?.account_usage &&
                        "text-danger"
                      }`}
                    >
                      Account Usage <span className='text-danger'>*</span>
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <Select
                      ref={accountUsageSelectRef}
                      isError={errors?.account_usage && touched?.account_usage}
                      name='account_usage'
                      id='account_usage'
                      data={accountUsage.map((item, i) => ({
                        label: item,
                        value: i + 1,
                      }))}
                      value={values.account_usage}
                      onChange={(selectedOption) => {
                        setFieldValue("account_usage", selectedOption?.value);
                        if (selectedOption?.value === 1) {
                          setGlgroup({
                            ...glgroup,
                            error: "",
                          });

                          GLSelectRef?.current?.clearValue();
                        }
                      }}
                      onBlur={() => {
                        handleBlur({ target: { name: "account_usage" } });
                      }}
                    />
                    {errors?.account_usage && touched?.account_usage && (
                      <p className='text-danger  mb-0'>
                        {errors?.account_usage}
                      </p>
                    )}
                  </div>
                </div>
                {values?.account_usage === 2 && (
                  <div className='row mb-3'>
                    <div className='col-md-4 text-end sm-text-end'>
                      <label htmlFor='gl_group' className={`form-label`}>
                        GL Groups
                      </label>
                    </div>
                    <div className='col-md-8'>
                      <Select
                        ref={GLSelectRef}
                        isError={glgroup?.error && true}
                        name='gl_group'
                        id='gl_group'
                        data={gl_groups.map((item, i) => ({
                          label: item,
                          value: item,
                        }))}
                        value={values.gl_group}
                        onChange={(selectedOption) =>
                          setFieldValue("gl_group", selectedOption?.value)
                        }
                      />
                      {glgroup?.error && (
                        <p className='text-danger'>{glgroup?.error}</p>
                      )}
                    </div>
                  </div>
                )}

                <div className='flex align-items-end'>
                  <label
                    className='form-label'
                    htmlFor='manual_entries'
                    style={{
                      textAlign: "right",
                      paddingRight: "25px",
                      width: "35%",
                    }}
                  >
                    <p>Manual entries Allowed?</p>
                  </label>
                  <input
                    className={`form-check-input `}
                    type='checkbox'
                    id='manual_entries'
                    name='manual_entries'
                    value={values?.manual_entries}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{ height: "22px", width: "20px" }}
                  />
                </div>

                <div className='row'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label htmlFor='' className={`form-label `}>
                      Description
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <textarea
                      className='form-control form-control-sm'
                      id='description'
                      name='description'
                      value={values?.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder='Enter description here'
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer me-3'>
              <button
                type='button'
                className='btn btn-secondary btn-sm rounded-3'
                data-bs-dismiss='modal'
                onClick={() => {
                  resetForm();
                  form.current.reset();
                }}
              >
                Close
              </button>
              <button
                type='submit'
                className='btn btn-primary btn-sm rounded-3'
              >
                Add
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddAccount;
